import React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import PublicShell from "./PublicShell";

const AboutPage: React.FC = () => {
  return (
    <PublicShell>
      <Paper
        variant="elevation3"
        sx={{
          p: { xs: 3, md: 4 },
          borderRadius: 3,
          background:
            "linear-gradient(180deg, rgba(55,71,79,0.8) 0%, rgba(38,50,56,0.95) 100%)",
          border: "1px solid rgba(255,255,255,0.08)",
        }}
      >
        <Stack spacing={2}>
          <Typography variant="overline" color="secondary.light">
            Om oss
          </Typography>
          <Typography variant="h4" sx={{ fontWeight: 800 }}>
            Bluu er laget for å holde norske selskaper i flytsonen.
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Vi bygger verktøy som kobler finans, salg, support og drift i én
            sømløs opplevelse. Fokus på sikkerhet, stabilitet og en tydelig pris
            gjør at du kan vokse uten overraskelser.
          </Typography>
          <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, gap: 3 }}>
            <Stack spacing={1}>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                Tydelig pris
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Forutsigbar lisens og moduler du kan slå av og på. Ingen skjulte
                kostnader.
              </Typography>
            </Stack>
            <Stack spacing={1}>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                Klar for samarbeid
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Alle roller jobber i samme system med innsikt og tilgang på tvers
                av team.
              </Typography>
            </Stack>
            <Stack spacing={1}>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                Pålitelig drift
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Skybasert og sikkert, bygget for nordiske krav til datahåndtering.
              </Typography>
            </Stack>
            <Stack spacing={1}>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                Rask onboarding
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Klare onboarding-løp med register/logg inn direkte fra
                forsiden.
              </Typography>
            </Stack>
          </Box>
        </Stack>
      </Paper>
    </PublicShell>
  );
};

export default AboutPage;
